const updateAddDocumentCompanies = {
  toastr: 'Document updated',
  toastr1: 'The document was successfully updated'
};

export default updateAddDocumentCompanies;
